
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function BookPunetonashikcab() {



    const cardData =
    {
        keyword: 'Pune to Nashik Taxi Services',
        heading: 'S9 Travels: Pune to Nashik Taxi Services ',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Nashik. Whether you are heading for a pilgrimage, a weekend getaway, or a business trip, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Nashik is approximately 210 km from Pune, and the journey takes around 4 to 5 hours by road. Enjoy a safe and comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Nashik with S9 Travels',

        "topPlaces": [
    {
        "title": "Kalaram Sansthan Temple",
        "description": "One of the most famous temples in Nashik, the Kalaram Sansthan Temple is dedicated to Lord Rama. This sacred site is believed to be the place where Lord Rama, his brother Laxman, and wife Sita visited during their exile. The ancient temple, with its beautiful architecture and spiritual significance, draws devotees from all over the country."
    },
    {
        "title": "Saptashrungi Temple",
        "description": "Located atop a hill, Saptashrungi Temple is a revered pilgrimage site in Nashik. Dedicated to the Goddess Saptashrungi, it is believed to be one of the 51 Shakti Peethas. A visit here requires a steep climb, offering both spiritual satisfaction and breathtaking views of the surrounding landscape."
    },
    {
        "title": "Trimbakeshwar Temple",
        "description": "A prominent Jyotirlinga site, the Trimbakeshwar Temple is dedicated to Lord Shiva and is located in the town of Trimbak, about 30 km from Nashik. The temple’s stunning architecture and religious significance make it a must-visit destination for pilgrims and tourists alike."
    },
    {
        "title": "Nashik Wine Tour",
        "description": "Nashik is often referred to as the 'Wine Capital of India.' The region is home to several vineyards, where visitors can take guided tours and sample some of the best wines. Popular vineyards like Sula Vineyards and York Winery offer tours that allow you to learn about wine production and enjoy wine tasting amidst picturesque vineyards."
    },
    {
        "title": "Pandav Leni Caves",
        "description": "The Pandav Leni caves are ancient rock-cut Buddhist caves situated on the Trimbak Road. These caves, believed to have been constructed between the 1st century BCE to the 3rd century CE, are home to intricately carved sculptures and offer insight into Buddhist culture."
    },
    {
        "title": "Anjneri Hill",
        "description": "Anjneri Hill is believed to be the birthplace of Lord Hanuman. It offers a scenic trekking experience and is popular among adventure enthusiasts. The trek to the hilltop rewards visitors with panoramic views of the surrounding landscape and the peaceful ambiance of the region."
    },
    {
        "title": "Godavari River",
        "description": "The Godavari River is one of the most sacred rivers in India, and Nashik is one of the places where it flows. A visit to the riverbanks provides a serene and spiritual experience. The ghats along the river offer peaceful surroundings for meditation and reflection."
    },
    {
        "title": "Khandoba Temple",
        "description": "Located on a hilltop, Khandoba Temple is dedicated to Lord Khandoba, a popular deity in Maharashtra. The temple is renowned for its religious significance and offers magnificent views of the surrounding hills and valleys."
    },
    {
        "title": "Jain Mandir",
        "description": "Nashik also has a significant Jain community, and the Jain Mandir in the city is an important place of worship. The temple's intricate architecture and peaceful environment make it a calming place to visit and explore Jainism's rich heritage."
    },
    {
        "title": "Nashik Fort (Malkapur Fort)",
        "description": "The Nashik Fort is an ancient fort that stands as a testament to Nashik’s historical significance. A trek up to the fort reveals its strategic importance and offers an incredible view of the surrounding landscapes. History buffs will enjoy exploring the fort's ruins and learning about the region's past."
    }
],

"services": [
  {
    "name": "Pune to Nashik Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Nashik. Whether you're traveling for business, leisure, or religious visits, enjoy a smooth and hassle-free ride with us. Book your Pune to Nashik taxi today!"
  },
  {
    "name": "Pune to Nashik Cab Booking",
    "description": "Booking a cab from Pune to Nashik is easy with S9 Travels. Whether you prefer booking online or over the phone, we offer flexible and convenient options to ensure your travel is stress-free and enjoyable."
  },
  {
    "name": "Pune to Nashik Cab Service",
    "description": "Choose S9 Travels for a professional and reliable cab service from Pune to Nashik. Our drivers are experienced, and our vehicles are well-maintained, ensuring a smooth and comfortable journey for you."
  },
  {
    "name": "Pune to Nashik Taxi Fare",
    "description": "S9 Travels provides transparent and affordable taxi fares for your Pune to Nashik journey. Our pricing is competitive, ensuring great value without any hidden charges. Know your fare upfront and plan your trip accordingly."
  },
  {
    "name": "Pune to Nashik Car Rental",
    "description": "Looking for a car rental service for your Pune to Nashik trip? S9 Travels offers flexible car rental options, giving you the freedom to travel at your own pace. Choose from a variety of vehicles to suit your needs and preferences."
  },
  {
    "name": "Pune to Nashik One-Way Taxi",
    "description": "For a one-way ride from Pune to Nashik, S9 Travels offers affordable and reliable one-way taxi services. Travel directly to your destination with a comfortable and convenient ride at a competitive price."
  },
  {
    "name": "Pune to Nashik Round Trip",
    "description": "S9 Travels provides round trip services from Pune to Nashik, ensuring a comfortable and convenient journey. Whether it's a business or leisure trip, our professional drivers and well-maintained vehicles will make your trip hassle-free."
  },
  {
    "name": "Pune to Nashik Luxury Taxi",
    "description": "For those who prefer a more luxurious experience, S9 Travels offers premium luxury taxi services for your Pune to Nashik trip. Enjoy enhanced comfort, extra space, and a smooth ride, making your journey truly special."
  },
  {
    "name": "Pune to Nashik Efficient  Taxi",
    "description": "S9 Travels offers Efficient Taxi services for a more budget-friendly option. Share the ride with others and still enjoy the comfort and convenience of a professional taxi service, all at an affordable price."
  },
  {
    "name": "Pune to Nashik Private Cab",
    "description": "For a private and personalized experience, book a private cab with S9 Travels. Our private cab service offers the privacy, comfort, and flexibility you need for your journey from Pune to Nashik. Travel at your own pace with complete comfort."
  }
],


"tableData": [
  ["Book Pune To Nashik Taxi", "Book Pune To Nashik Cab Booking"],
  ["Book Pune To Nashik Cab Service", "Book Pune To Nashik Taxi Fare"],
  ["Book Pune To Nashik Car Rental", "Book Pune To Nashik One-Way Taxi"],
  ["Book Pune To Nashik Round Trip", "Book Pune To Nashik Luxury Taxi"],
  ["Book Pune To Nashik Efficient Taxi", "Book Pune To Nashik Private Cab"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand that punctuality is crucial when traveling from Pune to Nashik. Whether you're heading for a religious pilgrimage, a business trip, or a weekend getaway, our drivers ensure timely pickups and drop-offs, keeping your journey stress-free."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a variety of comfortable vehicles for your journey to Nashik. From sedans to SUVs, all our vehicles are equipped with air conditioning, spacious seating, and modern amenities to ensure a pleasant and relaxing trip."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are skilled in handling long-distance trips and know the best routes to Nashik. They prioritize your safety and comfort, ensuring you have a smooth and enjoyable experience on the road."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels provides affordable and transparent pricing for your Pune to Nashik trip. There are no hidden fees, and we give you a clear breakdown of the costs upfront, so you can travel with confidence."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. Our vehicles are equipped with essential safety features, including airbags, seat belts, and GPS tracking, to ensure you have a secure and comfortable ride from Pune to Nashik."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "We operate 24/7 to accommodate your travel needs. Whether you're planning a morning departure or a late-night return, S9 Travels is always available to assist you, with our customer service team ready to support you at any time."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Nashik cab with S9 Travels is easy and convenient. You can book online through our website or mobile app, or you can get in touch with our customer service team for any help with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're traveling for business, leisure, or religious purposes, we offer personalized travel packages tailored to your preferences. Let us know your needs, and we'll ensure your trip is a memorable one."
  }
]







    }





    const faqData = [
        [
          {
            question: 'How can I book a Pune to Nashik cab with S9 Travels?',
            answer: 'Booking a cab is simple! You can book online via our website or app, or you can contact our customer service team for personalized assistance.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are experienced and skilled in long-distance travel, ensuring a safe and smooth ride to Nashik.',
          },
          {
            question: 'What types of vehicles are available for Pune to Nashik travel?',
            answer: 'We offer a variety of well-maintained vehicles, including sedans, SUVs, and premium cars, all designed for comfort on long trips.',
          },
          {
            question: 'How do I pay for my Pune to Nashik cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making your payment process simple and secure.',
          },
          {
            question: 'Can I book a round trip from Pune to Nashik?',
            answer: 'Yes, we can arrange round trips. Just let us know your return details, and we\'ll take care of the rest.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'If there are any extra charges, like for waiting or detours, we\'ll inform you clearly at the time of booking to ensure complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Nashik?',
            answer: 'Yes, we offer sightseeing tours in Nashik. Explore famous spots like the Trimbakeshwar Temple and other local attractions with our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Nashik cab?',
            answer: 'Our vehicles can easily accommodate standard luggage. If you have more luggage or special requirements, just let us know during booking, and we\'ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Nashik?',
            answer: 'Yes, we provide corporate travel services for group trips or business-related visits between Pune and Nashik.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Nashik travel?',
            answer: 'With S9 Travels, you can expect reliable, comfortable, and affordable journeys. Our professional drivers, well-maintained vehicles, and transparent pricing ensure a safe and enjoyable trip every time.',
          },
        ]
      ];
      

    const testimonialsData = [
        {
          name: 'Mr. Arvind Rao',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“I booked a cab with S9 Travels for my trip to Nashik. The driver was professional, and the vehicle was comfortable and well-maintained. I had a smooth and enjoyable journey. Highly recommend!”',
        },
        {
          name: 'Mrs. Anita Kulkarni',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“Our family traveled to Nashik with S9 Travels, and it was a fantastic experience. The driver was polite, the car was spacious, and the entire journey was relaxing. We will definitely use their services again!”',
        },
      ];
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Pune To Nashik Cab",
        "description": "Book Pune To Nashik taxi or cab services for one-way, round trip, luxury, private, and Efficient options. Affordable fares for Pune to Nashik car rental and taxi booking. Reliable and comfortable rides for your journey.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
      
      
      


    return (
        <div>
       
       

       <Helmet>
  <title>Book Pune To Nashik Cab | S9 Travels | Contact: +91 8850328441</title>
  <meta name="description" content="Book Pune To Nashik taxi or cab services with S9 Travels. Choose from one-way, round trip, luxury and private options. Affordable fares for Pune to Nashik car rental and taxi booking. Reliable and comfortable rides for your journey." />
  
  {/* Inject JSON-LD Schema */}
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/1.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default BookPunetonashikcab;